import React from "react";

export const LoadingSpinner = ({ t }) => {
  return (
    <div className="text-center p-4">
      <div className="spinner-border" role="status">
        <span className="sr-only">{t("Chargement")}...</span>
      </div>
    </div>
  );
};
